import { render } from "./Numproducts.vue?vue&type=template&id=0c6cf2a0"
import script from "./Numproducts.vue?vue&type=script&lang=js"
export * from "./Numproducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__